module.exports = __webpack_public_path__ + "static/media/IconAwesomeComments.c9d76fad.svg";